import { useRef, useContext, useState } from "react";
// * Packages
import { useCookies } from "react-cookie";
// import DatePicker from "react-datepicker";
// import moment from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';

// * Styles
import SlideStyle from "../../../../styles/Slide/style.module.css";
import "../../../../components/DataInputFields/TextInputField/TextInputField.css";
// * Micro Components
import {Full_Name} from "../../../../constants";
import TextInputField from "../../../DataInputFields/TextInputField/TextInputField";
import DateInputField from "../../../DataInputFields/DateInputField/DateInputField";
import ContinueButton from "../../../Buttons/SlideContinueButton/ContinueButton";
import PowerdByRoopya from "../../../../components/PowerdByRoopya/PowerdByRoopya";
// ** Error messagres aand error types
import * as Errors from "../../../../utils/errors";
// * Helpers
import { calculateAge2, getCookiePathFromURL } from "../../../../helpers";
import { calculateAge } from "../../../../utils/common";
// * Utilities
import { validatePAN, formatDate } from "../../../../utils";
// * Contexts
import CustomerContext from "../../../../context/CustomerContext";
import ErrorContext from "../../../../context/ErrorProvider";
// * Constants
import { CUSTOMER_AGE } from "../../../../constants";

// * Images
import YouindiLogo from "../../../../imagesLogo/youindiLogo.png";
import "../../../../styles/JourneyRightSection/responsive.css";
const Slide = ({
  ageRef,
  loading,
  setLoading,
  activeSlide,
  switchToNextSlide,
  updateJourneyData,
  ContactID,
  orgLogoData
}) => {
  const CookiePath = getCookiePathFromURL(window.location.href);

  // * Cookies
  // const [_, setCookie] = useCookies(["user"]);
  
  const [cookies, setCookie] = useCookies(["user"]);

  // * Refs and States
  const fullnameRef = useRef("");
  const panRef = useRef("");
  const dobRef = useRef("");
  const [dob, setDob] = useState(new Date());

  const { customerDetails, setCustomerDetails } = useContext(CustomerContext);
  // * State to handle Journey error
  const { error, setError } = useContext(ErrorContext);

  // * Main Function
  async function addIndividualDetails() {
    
    const fullName = fullnameRef.current.value;
    // const DOB = dobRef.current.value;
    const DOB = dob;
    const PAN = panRef.current.value;

    if (!handleFullName(fullName, Errors.FULLNAME_ERROR_TYPE)) {
      return false;
    }
    if (!handleDOB(formatDate(DOB), Errors.DOB_ERROR_TYPE)) {
      return false;
    }
    if (!handlePAN(PAN, Errors.PAN_ERROR_TYPE)) {
      return false;
    }
    if (!error.error) {
      window.webengage.track("Full Name", {
        "Name Entered": fullName,
      });
      window.webengage.track("DOB", {
        "Value Entered": DOB,
      });
      window.webengage.user.setAttribute(
        "we_first_name",
        fullName.split(" ")[0]
      );
      window.webengage.user.setAttribute(
        "we_last_name",
        fullName.split(" ")[1]
      );
      window.webengage.user.setAttribute("we_birth_date", DOB);

      setError({
        error: false,
        type: "",
        message: "",
      });
      setLoading(true);
      const data = {
        id: ContactID,
        full_name: fullName.trim(),
        date_of_birth: DOB,
        pan: PAN.toUpperCase(),
      };
      // * Saving Details to access through out the Journey.
      setCustomerDetails({
        ...customerDetails,
        // id: ContactID,
        fullName: fullName.trim(),
        dateOfBirth: DOB,
        pan: PAN,

      });
      setCookie(Full_Name,fullName.trim(), {
        path: CookiePath,
      });
      console.log("Full_Name:12345",fullName.trim() );
      const response = await updateJourneyData(data);

      if (response) {
        const customerAge = calculateAge2(DOB);
        ageRef.current = customerAge;
        setCookie(CUSTOMER_AGE, customerAge, { path: CookiePath });

        switchToNextSlide(activeSlide + 1);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  }

  // * Handlers
  function handleFullName(fullName, errorType) {
    if (fullName === "") {
      setError({
        error: true,
        type: errorType,
        message: Errors.FULLNAME_ERROR,
      });
      return false;
    }
    if (/[0-9]/.test(fullName)) {
      setError({
        error: true,
        type: errorType,
        message: Errors.FULLNAME_DIGIT_ERROR,
      });
      return false;
    }
    if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(fullName)) {
      setError({
        error: true,
        type: errorType,
        message: Errors.FULLNAME_SPECIAL_CHARACTER_ERROR,
      });
      return false;
    }
    if (error.error && error.type === errorType) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }

  function handleDOB(DOB, errorType) {
    setDob(DOB);

    if (DOB === "") {
      setError({
        error: true,
        type: errorType,
        message: Errors.DOB_ERROR,
      });
      return false;
    }
    const SeperateDOB = DOB.split("-");
    const currentYear = new Date().getFullYear();
    if (currentYear === SeperateDOB[0] || currentYear < SeperateDOB[0]) {
      setError({
        error: true,
        type: errorType,
        message: Errors.SAME_DATE_ERROR,
      });
      return false;
    }
    const Age = calculateAge(
      new Date(SeperateDOB[0], SeperateDOB[1], SeperateDOB[2])
    );
    if (Age < 18) {
      setError({
        error: true,
        type: errorType,
        message: Errors.DOB_NOT_ELIGIBLE_ERROR,
      });
      return false;
    }
    dobRef.current = DOB;
    if (error.error && error.type === errorType) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }

  // function handleDOB(selectedDate, errorType) {
  //   setDob(selectedDate);

  //   const formattedDate = moment(selectedDate).format("DD-MMM-YYYY");

  //   if (formattedDate === "") {
  //     setError({
  //       error: true,
  //       type: errorType,
  //       message: Errors.DOB_ERROR,
  //     });
  //     return false;
  //   }

  //   // ... other validation logic
  //   const SeperateDOB = formattedDate.split("-");
  //   const currentYear = new Date().getFullYear();
  //   if (currentYear === SeperateDOB[0] || currentYear < SeperateDOB[0]) {
  //     setError({
  //       error: true,
  //       type: errorType,
  //       message: Errors.SAME_DATE_ERROR,
  //     });
  //     return false;
  //   }
  //   const Age = calculateAge(
  //     new Date(SeperateDOB[0], SeperateDOB[1], SeperateDOB[2])
  //   );
  //   if (Age < 18) {
  //     setError({
  //       error: true,
  //       type: errorType,
  //       message: Errors.DOB_NOT_ELIGIBLE_ERROR,
  //     });
  //     return false;
  //   }


  //   dobRef.current = formattedDate;

  //   if (error.error && error.type === errorType) {
  //     setError({
  //       error: false,
  //       type: "",
  //       message: "",
  //     });
  //     return true;
  //   }

  //   return true;
  // }

  function handlePAN(PAN, errorType) {
    if (PAN === "") {
      setError({
        error: true,
        type: errorType,
        message: Errors.PAN_ERROR,
      });
      return false;
    }
    if (!validatePAN(PAN)) {
      setError({
        error: true,
        type: errorType,
        message: Errors.INVALID_PAN_ERROR,
      });
      return false;
    }
    if (error.error && error.type === errorType) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }

  return (
    <div className={SlideStyle.carouselSlideWrapper}>
    <div className="logoBox">
        <img
          style={{ marginTop: "-25px" }}
          //src={YouindiLogo}
          src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
        />
      </div>
      <div className={SlideStyle.typographyContainer}>
        <h1>Enter Individual Details</h1>
        <p>Please fill all the details carefully.</p>
      </div>
      {/* Input Fields */}
      <div className={SlideStyle.dataFieldsContainer}>
        {/* Fullname Input Field */}
        <TextInputField
          type="text"
          label="Full Name (As per PAN)"
          placeholder="Enter Full Name"
          name="fullname"
          id="fullname"
          reference={fullnameRef}
          required={true}
          errorType={Errors.FULLNAME_ERROR_TYPE}
          handler={(fullName) =>
            handleFullName(fullName, Errors.FULLNAME_ERROR_TYPE)
          }
          // onEnterHandler={addIndividualDetails}
        />
        {/* Date of Birth Input Field */}
        <TextInputField
          type="date"
          label="Date of Birth"
          placeholder="DD-MM-YYYY"
          name="dob"
          id="dob"
          minLength="1960-01-01"
          maxLength={`${new Date().getFullYear()}-01-01`}
          reference={dobRef}
          required={true}
          errorType={Errors.DOB_ERROR_TYPE}
          handler={(dob) => handleDOB(dob, Errors.DOB_ERROR_TYPE)}
          onEnterHandler={addIndividualDetails}
        />
        {/* <div className="inputContainer">
          <label htmlFor="dob">Date of Birth</label>
          <div className="dataFieldBox">
          <DatePicker className="dataField"
            name="dob"
            id="dob"
            selected={dob}
            required={true}
            errorType={Errors.DOB_ERROR_TYPE} 
            onChange={(date) => handleDOB(date, Errors.DOB_ERROR_TYPE)}
            dateFormat="dd-MMM-yyyy"
            maxDate={new Date()}
            showYearDropdown
            placeholderText="DD-MM-YYYY"
             
          />
          </div>
        </div> */}
        
        {/* PAN Input Field */}
        <TextInputField
          type="text"
          label="PAN"
          maxLength="10"
          minLength="10"
          placeholder="Enter PAN"
          name="pan"
          id="pan"
          reference={panRef}
          required={true}
          uppercase={true}
          errorType={Errors.PAN_ERROR_TYPE}
          handler={(pan) => handlePAN(pan, Errors.PAN_ERROR_TYPE)}  
          onEnterHandler={addIndividualDetails}
        />
      </div>

      {/* Continue Slide Button */}
      <div className={SlideStyle.continueBtn}>
        <ContinueButton
          loading={loading}
          handler={addIndividualDetails}
          // handler={() => setActiveSlide((prev) => prev + 1)}
        />
        <div className="tncCheckBox">
          <PowerdByRoopya />
        </div>
      </div>
      
    </div>
  );
};

export default Slide;
